"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createFollowSharedState = void 0;

var createFollowSharedState = function createFollowSharedState(initialState) {
  var state = initialState;
  var handlers = [];

  var getState = function getState() {
    return state;
  };

  var setState = function setState(newState) {
    state = newState;
    handlers.forEach(function (handler) {
      return handler(state);
    });
  };

  var onChange = function onChange(handler) {
    handlers.push(handler);
    return function () {
      handlers = handlers.filter(function (h) {
        return h !== handler;
      });
    };
  };

  return {
    getState: getState,
    setState: setState,
    onChange: onChange
  };
};

exports.createFollowSharedState = createFollowSharedState;